import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { WhoAreWe } from './components/WhoAreWe';
import { Footer } from './components/Footer';
import { AccessibilityMenu } from './components/AccessibilityMenu';
import { TopBanner } from './components/TopBanner';
import { FAQ } from './pages/FAQ';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Employees } from './pages/Employees';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen flex flex-col bg-white" data-id="element-2">
        <div className="relative z-40" data-id="element-3">
          <TopBanner data-id="element-4" />
        </div>
        <Header data-id="element-5" />
        <main className="flex-grow" data-id="element-6">
          <Routes data-id="element-7">
            <Route path="/" element={<Home data-id="element-9" />} data-id="element-8" />
            <Route path="/about" element={<About data-id="element-11" />} data-id="element-10" />
            <Route path="/services" element={<Services data-id="element-13" />} data-id="element-12" />
            <Route path="/employees" element={<Employees data-id="element-15" />} data-id="element-14" />
            <Route path="/faq" element={<FAQ data-id="element-17" />} data-id="element-16" />
          </Routes>
        </main>
        <Footer data-id="element-18" />
        <AccessibilityMenu data-id="element-19" />
      </div>
    </BrowserRouter>;
}